var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-profile w-100"},[_c('info-cupo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }